module.exports = __webpack_public_path__ + "img/home-folio.ba732e9.jpg";